import Vuex from 'vuex';
import components from '@/store/components';
import global from '@/store/global';
import websites from '@/store/cms/websites';
import informations from '@/store/cms/informations';
import authlog from '@/store/core/authlog';
import changelog from '@/store/core/changelog';
import roles from '@/store/core/roles';
import teams from '@/store/core/teams';
import users from '@/store/core/users';
import substitutions from '@/store/core/substitutions';

export default new Vuex.Store({
    strict: false,
    modules: {
        components: components,
        global: global,
        cms: {
            namespaced: true,
            modules: {
                websites: websites,
                informations: informations
            }
        },
        core: {
            namespaced: true,
            modules: {
                authlog: authlog,
                changelog: changelog,
                roles: roles,
                teams: teams,
                users: users,
                substitutions: substitutions,
            }
        }
    }
});
